var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel panel-gray wraper" },
    [
      _c(
        "div",
        { staticClass: "panel-header compact", attrs: { id: "list-header" } },
        [
          _c("q-btn-toggle", {
            attrs: {
              color: "white",
              "no-caps": "",
              dense: _vm.$route.name !== "cases",
              "text-color": "primary",
              "toggle-color": "primary",
              options: [
                { label: "Все", value: "all" },
                { icon: "photo_camera", value: "image" },
                { icon: "videocam", value: "video" },
                { icon: "mic", value: "audio" },
                { icon: "insert_drive_file", value: "application" },
                { icon: "delete", value: "unlinked" }
              ]
            },
            model: {
              value: _vm.filter,
              callback: function($$v) {
                _vm.filter = $$v
              },
              expression: "filter"
            }
          }),
          _vm._v(" "),
          _c("q-input", {
            staticClass: "q-ml-md",
            staticStyle: { "max-width": "400px", "margin-top": "-10px" },
            attrs: {
              name: "nameFilter",
              "float-label": "&#128269; в названии",
              clearable: "",
              disabled: _vm.filter === "unlinked"
            },
            model: {
              value: _vm.nameFilter,
              callback: function($$v) {
                _vm.nameFilter = $$v
              },
              expression: "nameFilter"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row group",
          class: { scroll: _vm.$route.meta.showLeft }
        },
        [
          _vm._l(_vm.visibleMedias, function(item) {
            return _c("galery-item", {
              key: item.key,
              attrs: { item: item, view: _vm.viewMedia, goEdit: _vm.goEdit }
            })
          }),
          _vm._v(" "),
          _c(
            "my-scroll",
            { ref: "myscroll", attrs: { handler: _vm.getMore } },
            [_c("q-spinner-dots", { attrs: { size: 40 } })],
            1
          ),
          _vm._v(" "),
          _c(
            "q-btn",
            {
              directives: [
                {
                  name: "back-to-top",
                  rawName: "v-back-to-top.animate",
                  value: 500,
                  expression: "500",
                  modifiers: { animate: true }
                }
              ],
              staticClass: "fixed-bottom-left",
              staticStyle: { margin: "0 0 15px 15px" },
              attrs: { round: "", color: "teal-5" }
            },
            [_c("q-icon", { attrs: { name: "keyboard_arrow_up" } })],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": "background-color: transparent; box-shadow: none;",
            minimized: ""
          },
          on: { show: _vm.play },
          model: {
            value: _vm.audio,
            callback: function($$v) {
              _vm.audio = $$v
            },
            expression: "audio"
          }
        },
        [
          _vm.audioUrl
            ? _c("audio", {
                attrs: { id: "a", src: _vm.audioUrl, controls: "" }
              })
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.mode === "slim"
        ? _c("slim-cropper", {
            ref: "slim",
            attrs: { options: _vm.slimOptions, data: _vm.blob }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "q-modal",
        {
          attrs: { maximized: "", "content-classes": "panel mediator" },
          model: {
            value: _vm.resizemode,
            callback: function($$v) {
              _vm.resizemode = $$v
            },
            expression: "resizemode"
          }
        },
        [
          _c(
            "div",
            { staticClass: "panel-header" },
            [
              _c("q-btn", {
                attrs: {
                  title: "Закрыть",
                  color: "primary",
                  icon: "clear",
                  small: "",
                  round: "",
                  flat: ""
                },
                on: { click: _vm.didCancel }
              }),
              _vm._v(" "),
              _c("q-btn", {
                attrs: {
                  disabled: !_vm.blob,
                  color: "positive",
                  icon: "done",
                  small: "",
                  round: "",
                  flat: "",
                  title: "Сохранить"
                },
                on: { click: _vm.doSave }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "panel-body" },
            [
              _vm.mode === "resize"
                ? _c("pic-resize", {
                    attrs: {
                      maxHeight: _vm.picMaxHeight,
                      url: _vm.picUrl,
                      picIniSize: _vm.picIniSize,
                      editableFormat: _vm.editableFormat,
                      maxQuality: 101
                    },
                    model: {
                      value: _vm.blob,
                      callback: function($$v) {
                        _vm.blob = $$v
                      },
                      expression: "blob"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-759687c4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-759687c4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/medias-lazy.vue
// module id = null
// module chunks = 